import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Section, SectionHeading, Panel, Reveal, Eyebrow } from '../components/ui';
import Disclosure from '../components/ui/Disclosure';
import { TYPE } from '../theme/tokens';

export default function Faq() {
  const { t } = useTranslation();

  const answerOf = (key) => {
    const value = t(key, { returnObjects: true });
    return Array.isArray(value) ? value : [value];
  };

  const faqs = [
    { title: t('faq.clients.question'), details: answerOf('faq.clients.answer') },
    { title: t('faq.whyQuantikFlow.question'), details: answerOf('faq.whyQuantikFlow.answer') },
  ];

  return (
    <>
      <Section first component="header" sx={{ pb: { xs: 5, md: 7 } }}>
        <SectionHeading
          component="h1"
          align="center"
          eyebrow={t('faq.eyebrow')}
          title={t('faq.title')}
          lede={t('faq.subtitle')}
          titleSx={TYPE.h1}
        />
      </Section>

      <Section sx={{ pt: 0 }}>
        <Reveal sx={{ maxWidth: 820, mx: 'auto' }}>
          <Panel bodySx={{ px: { xs: 2.5, md: 4 } }}>
            <Disclosure items={faqs} />
          </Panel>
        </Reveal>
      </Section>

      {/* Întrebarea care nu e în listă are unde să meargă. */}
      <Section tone="deep">
        <Box sx={{ textAlign: 'center', maxWidth: 640, mx: 'auto' }}>
          <Reveal>
            <Eyebrow onDark sx={{ mb: 2 }}>
              {t('faq.ctaEyebrow')}
            </Eyebrow>
            <Typography component="h2" sx={{ ...TYPE.h2, color: 'var(--qf-deep-ink)', textWrap: 'balance', m: 0 }}>
              {t('faq.ctaTitle')}
            </Typography>
          </Reveal>

          <Reveal delay={0.1} sx={{ mt: { xs: 3.5, md: 4.5 } }}>
            <Button component={Link} to="/contact" variant="onDarkFilled" size="large">
              {t('home.ctaAction')}
            </Button>
          </Reveal>
        </Box>
      </Section>
    </>
  );
}
